import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    registeredOrders: [],
    currentPage: 1,
    totalItems: 0,
    totalPages: 0,
    itemsPerPage: 12,
    selectedOrder: {},
    paginaInicial: 0,
    paginaFinal: 0,
    orderDetailsModal: false,
    loadingOrderActions: false,
    loadingFeatured: false,
    searchOrders: '',
    orderPdf: ''
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/pedido/index.js